<template>
  <div>
    <div v-if="showOverview" class="purchase-summary-card">
      <div>
        <div class="purchase-summary-title">{{ title }}</div>
        <div class="purchase-summary-sub">
          <span v-if="unit">单位：{{ unit }}</span>
          <span v-if="displayDateText">服务日期：{{ displayDateText }}</span>
          <span v-if="timeSlotText">时段：{{ timeSlotText }}</span>
        </div>
      </div>
      <div class="purchase-summary-price">¥{{ totalPriceB2C || minPrice || 0 }}</div>
    </div>

    <div v-if="showSelectedList" class="purchase-form-card" :class="{ 'purchase-form-card--standalone': !showOverview }">
      <div class="purchase-block-title">已选清单</div>

      <div v-if="!selectedSkus.length" class="purchase-empty-inline">
        请选择规格和数量
      </div>

      <div v-else class="selected-sku-list">
        <div v-for="sku in selectedSkus" :key="sku.sku_id" class="selected-sku-item">
          <div>
            <div class="selected-sku-name">{{ sku.display_name || sku.sku_name }}</div>
            <div class="selected-sku-meta">数量 {{ sku.quantity }}{{ unit || '份' }}</div>
          </div>
          <div class="selected-sku-price">¥{{ getItemTotalPrice(sku) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopPurchaseSelectionSummary',
  props: {
    title: {
      type: String,
      default: '',
    },
    unit: {
      type: String,
      default: '',
    },
    displayDateText: {
      type: String,
      default: '',
    },
    timeSlotText: {
      type: String,
      default: '',
    },
    totalPriceB2C: {
      type: Number,
      default: 0,
    },
    minPrice: {
      type: Number,
      default: 0,
    },
    showOverview: {
      type: Boolean,
      default: true,
    },
    showSelectedList: {
      type: Boolean,
      default: true,
    },
    totalDays: {
      type: Number,
      default: 1,
    },
    selectedSkus: {
      type: Array,
      default() {
        return [];
      },
    },
    getSkuFinalPriceB2C: {
      type: Function,
      required: true,
    },
  },
  methods: {
    getItemTotalPrice(sku) {
      return this.getSkuFinalPriceB2C(sku) * sku.quantity * this.totalDays;
    },
  },
};
</script>

<style scoped>
.purchase-summary-card,
.purchase-form-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 16px 1px rgb(0 0 0 / 6%);
  padding: 20px 22px;
}

.purchase-summary-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);
}

.purchase-summary-title {
  color: #20314a;
  font-size: 20px;
  font-weight: bold;
}

.purchase-summary-sub {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 10px;
  color: #6b778c;
  font-size: 13px;
}

.purchase-summary-price {
  color: #1c5098;
  font-size: 34px;
  font-weight: bold;
}

.purchase-form-card {
  margin-top: 16px;
}

.purchase-form-card--standalone {
  margin-top: 0;
}

.purchase-block-title {
  color: #20314a;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 16px;
}

.purchase-empty-inline {
  padding: 40px 0;
  text-align: center;
  color: #999;
}

.selected-sku-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.selected-sku-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border: 1px solid #e8eef7;
  border-radius: 10px;
  background: #fbfdff;
  gap: 12px;
}

.selected-sku-name {
  color: #223046;
  font-size: 14px;
  font-weight: bold;
}

.selected-sku-meta {
  margin-top: 6px;
  color: #8b95a7;
  font-size: 12px;
}

.selected-sku-price {
  color: #1c5098;
  font-size: 18px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/pages/shop/components/ShopPurchaseSelectionSummary.vue